/**
 * @file: 加载微应用
 * @returns: 返回微应用的实例
 */

import { MicroApp } from 'qiankun';
import { FLoadConfig, FPageConfig, TPlatforms } from '../typings';
import { load as industryLoad } from '../webMicroApp/industryPlatform';
import { load as smartContactCMSLoad } from '../webMicroApp/smartCustomerCMS';
import store, { getAllPages } from '../store/index';

export default async function(config: FLoadConfig): Promise<MicroApp> {
  // 根据 PageID 进行各个平台进行分发
  const info: FPageConfig[] = getAllPages() as any;
  const pageInfo: FPageConfig = info.reduce((target: any, curr: FPageConfig) => {
    if (curr.appId === config.pageId) {
      target = curr;
    }
    return target;
  }, null);
  if (pageInfo?.platform === TPlatforms.INDUSTRY_PLATFORM) {
    return industryLoad({
      // 此处的路径需要从initial中获取
      entry: `${pageInfo.appUrl}${pageInfo.path}`,
      container: config.container,
      props: {
        baseApiUrl: pageInfo.apiBaseUrl,
        loginUrl: config?.props?.loginUrl || window.location.href,
        dispatch: (value: { type: string, data: any }) => { store.dispatch({ type: 'COMMIT_EVENT', payload: value }) },
        pageInfo,
        useNativeRoute: config.props?.useNativeRoute || 0,
        extra: config.props?.extra,
      },
    });
  } else if (pageInfo?.platform === TPlatforms.SMART_CONTACT_CMS) {
    return smartContactCMSLoad({
      // 此处的路径需要从initial中获取
      entry: `${pageInfo.appUrl}${pageInfo.path}`,
      container: config.container,
      props: {
        baseApiUrl: pageInfo.apiBaseUrl,
        loginUrl: config?.props?.loginUrl || window.location.href,
        dispatch: (value: { type: string, data: any }) => { store.dispatch({ type: 'COMMIT_EVENT', payload: value }) },
        pageInfo,
        useNativeRoute: config.props?.useNativeRoute || 0,
        extra: config.props?.extra,
      },
    });
  }
  return {
    unmount: async () => {
      // 移除实例
      return null;
    },
    update: async (props: any) => {
      // 更新实例, 返回新的state
      return null;
    },
    mount: async () => {
      return null;
    },
    getStatus: () =>  { return "NOT_LOADED"; },
    loadPromise: Promise.resolve(null),
    bootstrapPromise: Promise.resolve(null),
    unmountPromise: Promise.resolve(null),
    mountPromise: Promise.resolve(null),
  };
}
